import { useDispatch } from "react-redux";
import Mode from "../components/styles/Mode";
import cookies from "../utilities/Cookies";
import { updatedarkmode } from "../features/mode";
import { useEffect, useState } from "react";
import { Box, Container, Modal, Skeleton, Typography } from "@mui/material";
import Spacebox from "../components/Spacebox";
import Flexbox from "../components/Flexbox";
// import Button from "../components/Button";
import '../css/form.css'
import '../css/result-page.css'
// import { CheckRounded } from "@mui/icons-material";
// import { extractUTMParameters } from "../utilities/utils";
import algorithms from "../utilities/Algorithms";
// import ProgressWithStatuses from "../components/ProgressForResults";
import { isMobile } from 'react-device-detect'
import { determineOutboundNumber, getCurrentHourET, getUser, saveTrustedFormCert, triggerRetell1 } from "../utilities/utils";
// import LiveChatWidget from "../components/scripts/LivechatAI";
import Grid from "../components/Grid";
import BlurResults from "../components/Results-blur";
import Button from "../components/Button";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: isMobile ? '95%' : 600,
    maxHeight: isMobile ? '85dvh' : '100dvh',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 0,
    borderRadius: 5,
    overflow: 'hidden',
    border: '2px solid #2059ebff !important'
};

// const iframe = `<iframe
//   src="https://app.livechatai.com/aibot-iframe/cmietv5my0001lb04ssnmozfh"
//   style="border:1px solid #EAEAEA"
//   width="100%"
//   height="680"
//   frameborder="0"
//   allow="microphone"
// ></iframe>`

// const video_iframe = `<div style="height:300px; width: 100%; background: #f0f0f0;position:relative;border-radius: 0px 0px 5px 5px; overflow: hidden;"><iframe src="https://player.vimeo.com/video/1140526893?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;autoplay=1" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerpolicy="strict-origin-when-cross-origin" style="position:absolute;top:0;left:0;width:100%;height:100%;" title="FDR - VSL 2 - v2_16-9_60s_CC"></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>`


const ResultPage_Retell = () => {

    const dispatch = useDispatch()
    const currentHour = getCurrentHourET()
    const isWorkingHours = currentHour >= 8 && currentHour < 24 ? true : false

    const [firstname, setFirstname] = useState(null)
    const [, setLastname] = useState(null)
    const [, setEmail] = useState(null)
    const [, setPhone] = useState(null)
    const [contactId, setContactId] = useState(null)
    const [result, setResult] = useState()
    const [state, setState] = useState(null)
    const [loading,] = useState(false)

    const [openModal, setOpenModal] = useState(false)


    const scrollToTop = () => window.scrollTo({ behavior: 'smooth', top: 0 })

    // const updateParent = (url) => {
    //     window.parent.postMessage(
    //         { type: 'trigger', url: url },
    //         'https://www.finaldebtrelief.com'
    //     );
    // };

    // updateParent(`https://www.finaldebtrelief.com/trusted-cert-url-turbo1?contact_id=${contactId}&first_name=${firstname}&last_name=${lastname}&email=${email}&phone=${phone}&source=debt-calculator&page=cl${extractUTMParameters(['cluid', 'utm_source', 'utm_medium', 'utm_content', 'utm_campaign', 'utm_term', 'utm_id', 'ad_id', 'tw_source', 'tw_adid'])}`)

    // eslint-disable-next-line
    const handleClick = () => {
        if (currentHour >= 8 && currentHour < 24) {
            // 8am - 11:45pm
            // openChatWidget()
            // tag lead as "chat"
        } else if (currentHour === 24 || (currentHour > 0 && currentHour < 8)) {
            // schedule a call
            window.open('https://api.leadconnectorhq.com/widget/bookings/free-debt-relief-review-call', "_blank")
        }
    }

    // eslint-disable-next-line
    const openChatWidget = () => {
        const chatWidgetHost = document.querySelector('#live-chat-ai-host')
        if (chatWidgetHost) {
            const shadowRoot = chatWidgetHost.shadowRoot

            if (shadowRoot) {
                const chatBtn = shadowRoot.querySelector('#live-chat-ai-button')
                if (chatBtn) {
                    chatBtn.click()
                    chatBtn.style.opacity = 0
                    chatBtn.style.visibility = "hidden"
                } else console.log('chat_btn_not_accessible')
            } else console.log("shadowroot_not_accessible")
        } else {
            console.log('not_found')
        }
    }

    // eslint-disable-next-line
    const hideChtBtn = () => {
        let trials = 1
        const engine = setInterval(() => {
            const chatWidgetHost = document.querySelector('#live-chat-ai-host')
            if (chatWidgetHost) {
                const shadowRoot = chatWidgetHost.shadowRoot
                if (shadowRoot) {
                    const chatBtn = shadowRoot.querySelector('#live-chat-ai-button')
                    if (chatBtn) {
                        chatBtn.style.opacity = 0
                        chatBtn.style.visibility = "hidden"
                        clearInterval(engine)
                    }
                }
            } else {
                if (trials > 10)
                    clearInterval(engine)
                trials = trials + 1
            }
            console.log(trials)
            console.log('running')
        }, 1000);
    }

    const openCallScheduleModal = () => {
        // if (currentHour >= 18 && currentHour < 24) {
        //     setTimeout(() => {
        //         setOpenModal(true)
        //     }, 25_000)
        // }
    }

    const getUserState = async (contact_id) => {
        let val = await getUser(contact_id)
        if (typeof val === "string")
            setState(val)
    }

    useEffect(() => {
        scrollToTop()
        cookies.setCookies('mode', 'light', 10)
        dispatch(updatedarkmode({ dark: false }))

        openCallScheduleModal()

        const urlParams = new URLSearchParams(window.location.search)
        const contact_id = urlParams.get('contact_id')
        const first_name = urlParams.get('first_name')
        const last_name = urlParams.get('last_name')
        const email_ = urlParams.get('email')
        const phone_ = urlParams.get('phone')
        const result_ = urlParams.get('result')

        if (contact_id && first_name) {
            setContactId(contact_id)
            setFirstname(first_name)
            setLastname(last_name)
            setEmail(email_)
            setPhone(phone_)
            if (result_)
                setResult(JSON.parse(result_))
            else {
                const amount = urlParams.get('amount')
                if (amount) {
                    const res = algorithms.computeDebtPlan(parseFloat(amount))
                    setResult(res)
                }
            }
            getUserState(contact_id)

            if (!window.location.href.includes('localhost')) {
                triggerRetell1(contact_id)
                const trusted_cert = urlParams.get('trusted_form_cert_url')
                saveTrustedFormCert(trusted_cert, contact_id)
            }
            // initializeLeadConnector(contact_id, first_name, last_name, email_, phone_)
            // hideChtBtn()
        }

        // eslint-disable-next-line
    }, [])
    return (
        <Mode>
            <div className="result-page">
                {loading && (
                    <div>
                        <Flexbox justifyContent="center" alignItems="center" style={{ height: '90dvh', width: '100%' }}>
                            {/* <ProgressWithStatuses onComplete={() => {
                                setLoading(false)
                                hideChtBtn()
                            }} /> */}
                        </Flexbox>
                    </div>
                )}
                {!loading && <div>
                    {!contactId && !firstname && (
                        <Container>
                            <div className="margin-auto" style={{ maxWidth: '400px', padding: '10px' }}>
                                <Skeleton variant="rounded" width={"100%"} height={200} />
                                <Spacebox padding="10px" />
                                <Skeleton variant="rounded" width={100} height={15} />
                                <Spacebox padding="10px" />
                                <Skeleton variant="rounded" width="100%" height={10} />
                                <Spacebox padding="5px" />
                                <Skeleton variant="rounded" width="100%" height={10} />
                                <Spacebox padding="5px" />
                                <Skeleton variant="rounded" width="100%" height={10} />
                                <Spacebox padding="5px" />
                                <Skeleton variant="rounded" width="100%" height={10} />
                                <Spacebox padding="5px" />
                                <Skeleton variant="rounded" width="100%" height={10} />
                            </div>
                        </Container>
                    )}
                    {contactId && firstname && (
                        <div className="margin-auto mid" style={{ background: 'url("/assets/results-bg.png")', backgroundPosition: 'center', backgroundSize: 'cover' }}>
                            <div style={{ padding: 20 }}>
                                <span style={{ fontWeight: '700', fontSize: '32px' }} className="text-primary bold heading"><u>Your plan details are ready!</u></span>
                                <span style={{ display: 'block', textAlign: 'center', fontSize: '18px', marginTop: '10px' }}>
                                    <b className="bold">Our agents are call you now.</b>
                                </span>
                                {result && <div>
                                    <Spacebox padding="10px" />
                                    <BlurResults result={result} />
                                    <Spacebox padding="10px" />
                                </div>}
                                <div style={{ background: '#ffc670', padding: '10px', textAlign: 'center', borderRadius: '10px' }}>
                                    <span className="" style={{ fontSize: '16px' }}>
                                        We have found 2 qualifying programs for your debt.
                                        <span style={{ display: 'inline-block', fontSize: '16px' }} className="text-primary heading font-size-m-16">
                                            <u></u>
                                        </span> <b className="bold">Your custom debt relief options</b> are currently being finalized by our negotiation team
                                    </span>
                                </div>
                                {isWorkingHours && <div className="working-hours">
                                    <Spacebox padding="10px" />
                                    <p style={{ fontSize: '23px', textAlign: 'center' }} className="bold">
                                        <span className="trade-green bold">Please wait for our call in 60 seconds</span> <br />
                                        to unlock your final guaranteed numbers
                                    </p>
                                    {!isMobile && <Spacebox padding="40px" />}
                                    {isMobile && <Spacebox padding="10px" />}
                                    <div className="agent-banner" style={{ background: '#143467', border: '3px solid #ffffff83', borderRadius: '10px', margin: 'auto', padding: '20px 30px', width: 'fit-content', transform: isMobile ? 'scale(1.0) translateX(15px)' : 'scale(1.5)' }}>
                                        <div style={{ textAlign: 'center' }}>
                                            <span className="text-white">Our agent is calling you now from this number</span>
                                        </div>
                                        <Typography style={{ fontSize: isMobile ? '25px' : '30px', textAlign: 'center' }} className="trade-warning">
                                            {!state && <b className="bold">+1 (855) 780-4538</b>}
                                            {state && <b className="bold">{determineOutboundNumber(state)}</b>}
                                        </Typography>
                                    </div>
                                    {!isMobile && <Spacebox padding="40px" />}
                                    {isMobile && <Spacebox padding="10px" />}
                                    <div style={{ background: '#ff000010', padding: '15px 20px', borderRadius: '10px' }}>
                                        <Flexbox alignItems="center" justifyContent="center">
                                            <span style={{ display: 'block', textAlign: 'center' }}>
                                                <b className="trade-red">
                                                    Final Debt Relief only accepts <b>25 new enrollments per day</b> to ensure our negotiators can dedicate enough time to each file.
                                                </b>
                                            </span>
                                        </Flexbox>
                                    </div>
                                    <Spacebox padding="5px" />
                                    <div style={{ width: 'fit-content', padding: '10px 20px', borderRadius: '10px', margin: 'auto', background: '#fffce2' }}>
                                        <span className="text-primary"><u>You're #1 in queue</u></span>
                                    </div>
                                    <Spacebox padding="10px" />
                                    <p style={{ textAlign: 'center', fontSize: '25px' }}>
                                        ⏳ <b>Your spot is reserved for the</b> <span style={{ display: 'inline-block', fontSize: '25px' }} className="heading text-primary"><b><u>next 5 minutes</u></b></span>
                                    </p>
                                    <Spacebox padding="5px" />
                                    <p style={{ textAlign: 'center' }}>
                                        If you speak to a specialist within the first <b>5 minutes</b>,
                                        you'll receive <b>'Express Negotiation' status</b>, helping you resolve your debt within 24 - 48 months.
                                    </p>
                                </div>}
                                {!isWorkingHours && <div className="outside-working-hours">
                                    <Spacebox padding="10px" />
                                    <div className="text-primary" style={{ background: '#0068cf2c', padding: '10px', textAlign: 'center', borderRadius: '10px', border: '2px solid var(--secondary)' }}>
                                        <b> A debt relief specialist will call you during our working hours (8 AM - 11 PM) to review your options and verify your details.</b>
                                    </div>
                                    <Spacebox padding="10px" />
                                    <p style={{ fontSize: '23px', textAlign: 'center' }} className="bold">
                                        Prefer a specific time? <span style={{ display: 'inline-block' }} className="text-primary bold heading">Lock in your spot below.</span>
                                    </p>
                                    <Spacebox padding="2px" />
                                    <Flexbox alignItems="center" justifyContent="center">
                                        <Button
                                            handleClick={() => handleClick()}
                                            className="signature-btn"
                                            style={{ background: 'var(--secondary)', color: 'white', width: 'fit-content', padding: '10px 30px', borderRadius: '100px', fontSize: '1.1rem' }}
                                        >
                                            Lock in my Savings Now
                                        </Button>
                                    </Flexbox>
                                </div>}
                                <Spacebox padding="30px" />
                                <Grid grid={2} gap="20px">
                                    {['benefit-1.png', 'benefit-2.png'].map((ph, index) => (
                                        <img key={index} src={`/assets/results-page/${ph}`} style={{ width: '100%', filter: 'drop-shadow(0px 0px 20px #00000020)' }} alt="benefit" />
                                    ))}
                                </Grid>
                                <div>
                                    {/* <span>
                                        <b className="bold">Lock in your savings</b> today and get a personalized debt relief plan. Others are securing theirs right now. <b className="bold">Don't miss</b> your chance to take control of your debt. <br /><br />
                                        Every day you delay is another day of interest and fees. <br /> <b className="bold">Take the next step now.</b>
                                    </span>
                                    <Spacebox padding="10px" />
                                    <Flexbox alignItems="center" justifyContent="center">
                                        <Button
                                            handleClick={() => handleClick()}
                                            className="signature-btn"
                                            style={{ background: 'var(--secondary)', color: 'white', width: 'fit-content', padding: '10px 30px', borderRadius: '100px', fontSize: '1.1rem' }}
                                        >
                                            Lock in my Savings Now
                                        </Button>
                                    </Flexbox>
                                    <Spacebox padding="10px" />
                                    <Flexbox justifyContent="center">
                                        <small className="terms" style={{ opacity: 0 }}>
                                        <b>We value your privacy.</b>  By clicking the button above you consent to having your credit report accessed as explained underneath. This will not impact your credit. You understand that by clicking on the button above, you are providing written instructions to our <u>partner/ affiliates <span>TurboDebt, Beyond Finance LLC dba Accredited Debt Relief, First Choice Debt Relief, National Debt Relief and Cura Debt</span> </u> under the Fair Credit Reporting Act (and all relevant State Laws) authorizing them to obtain information from your personal credit report or other information from a credit bureau for debt settlement purposes only.
                                        </small>
                                    </Flexbox> */}
                                    <Spacebox padding="20px" />
                                </div>
                            </div>
                            {/* {(currentHour >= 10 && currentHour < 18) && <LiveChatWidget />} */}
                        </div>
                    )}
                </div>}
                <Modal
                    open={openModal}
                    onClose={() => setOpenModal(false)}
                >
                    <Box sx={style}>
                        <div style={{ padding: '20px' }}>
                            <span style={{ fontWeight: '700', color: '#2059ebff', fontSize: '28px' }} className="text-primary bold heading">It seems we just missed you!</span>
                            <Spacebox padding="10px" />
                            <div style={{ padding: '10px 30px', backgroundColor: '#eb202012', borderRadius: '10px' }}>
                                <span style={{ display: 'block', textAlign: 'center', lineHeight: '30px', color: '#eb2020ff' }}>
                                    <b className="bold">Hey {firstname}, Our agents just tried to call you, but missed you</b>, Please call this number <b>now</b> to lock in your savings. <br /><b><a href="tel:+12029987148" className="text-primary bold" style={{ fontSize: 23, color: '#eb2020ff', }}> 📞 (202) 998-7148</a></b>
                                </span>
                            </div>
                            <Spacebox padding="10px" />
                            <div style={{ padding: '10px 30px', backgroundColor: '#205aeb1b', borderRadius: '10px' }}>
                                <span style={{ display: 'block', textAlign: 'center', lineHeight: '30px', color: '#2059ebff' }} className="text-primary">
                                    If you can't chat now, please click here to schedule a call. <br /><b><a rel="noreferrer" target="_blank" href="https://api.leadconnectorhq.com/widget/bookings/fdr-call" className="bold" style={{ fontSize: 23, color: '#2059ebff', }}>
                                        📆 Schedule A Call
                                    </a></b>
                                </span>
                            </div>
                        </div>
                    </Box>
                </Modal>
            </div>
        </Mode>
    );
}

export default ResultPage_Retell;